import { ImageService } from '@/services';
import { prependImageDest } from '@util';

export default {
    namespaced: true,
    state: {
        imageList: {},
        categoryList: [],
        metaData: {},
        channels_path: {},
    },
    mutations: {
        setCategoryList(state, categoryList) {
            categoryList.pop(); // 'others' category dosen't have images.
            state.categoryList = categoryList;
        },
        setImgList(state, { category, data, channel }) {
            const value = data.map(
                ({
                    original_path,
                    thumbnail_path,
                    id,
                    meta,
                    channels_path,
                    form_path,
                }) => {
                    if (meta) state.metaData[id] = meta;
                    if (channels_path.length)
                        state.channels_path[id] = channels_path;
                    return {
                        original_path: prependImageDest(
                            channel === 'form'
                                ? form_path || original_path
                                : original_path
                        ),
                        thumbnail_path: prependImageDest(thumbnail_path),
                        id,
                    };
                }
            );
            state.imageList = {
                ...state.imageList,
                [category]: value,
            };
        },
        setImageListAfterUpload(state, image) {
            const {
                meta,
                channels_path,
                thumbnail_path,
                original_path,
                id,
            } = image;
            if (meta) state.metaData[id] = meta;
            if (channels_path.length) state.channels_path[id] = channels_path;
            const value = {
                original_path,
                thumbnail_path,
                id,
            };
            const myFileCategory = 'my_file';
            const newImageList = [value, ...state.imageList[myFileCategory]];
            state.imageList = {
                ...state.imageList,
                [myFileCategory]: newImageList,
            };
        },
    },
    actions: {
        getCategoryList({ commit }) {
            return ImageService.getCategoryList()
                .then(({ data }) => commit('setCategoryList', data))
                .catch(console.error);
        },
        getImageList({ commit, state }, { category, id, campaignId, channel }) {
            // if (state.imageList[category] && !isRenew) return; //block cached list
            return ImageService.getImageList(id, campaignId)
                .then(({ data }) =>
                    commit('setImgList', { category, data, channel })
                )
                .catch(console.error);
        },
        deleteMyFile({ dispatch }, { id, campaignId }) {
            return ImageService.deleteMyFiles(id, campaignId)
                .then(() => {
                    return dispatch('getImageList', {
                        category: 'my_file',
                        id: 1,
                        isRenew: true,
                        campaignId,
                    });
                })
                .catch(console.error);
        },
    },
    getters: {
        imageList: R.prop('imageList'),
        categoryList: R.prop('categoryList'),
        metaData: R.prop('metaData'),
        channels_path: R.prop('channels_path'),
    },
};
